import Vue from "vue";
import App from "./app.vue";
import router from "./router";
import store from "@/store";
import UlearningUI from 'ulearning-ui'
import { ORG_SITE } from '@/config'

import "ulearning-ui/lib/styles/index.css"

import 'element-ui/lib/theme-chalk/index.css';
Vue.use(UlearningUI)

import UlPage from './components/page'
Vue.use(UlPage)

import { Tooltip,Tree } from 'element-ui'
Vue.use(Tooltip)
Vue.use(Tree)

import "normalize.css"
import '@/assets/fonts/iconfont.css'
import "@/assets/fonts/iconfont.js";
import "./styles/common.scss"


router.beforeEach((to, from, next) => {
  // document.title = i18n.t(to.meta.title);
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});

const initVue = () => {
  new Vue({
    router,
    store,
    // i18n,
    render: h => h(App),
    created () {
      if (ORG_SITE != 'umooc') {
        store.dispatch('org/setOrg')
      }
    }
  }).$mount("#app");
};

store.dispatch("user/setUser")
  .then(() => {
    initVue()
  })
  .catch(err => {
    console.log(err)
    initVue()
  })